(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('MaterialTypeDeleteController',MaterialTypeDeleteController);

    MaterialTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'MaterialType'];

    function MaterialTypeDeleteController($uibModalInstance, entity, MaterialType) {
        var vm = this;

        vm.materialType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MaterialType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
